const LIST_PATH = "/contacts";

const PRESET_PARAMS = [
  ["entity_id", "entityId"],
  ["campaign_id", "campaignId"],
  ["lead_id", "leadId"],
  ["full_name", "fullName"],
  ["email", "email"],
  ["phone", "phone"],
];

const buildCreatePath = (preset = {}) => {
  const params = new URLSearchParams();
  PRESET_PARAMS.forEach(([param, key]) => {
    if (preset[key] != null && preset[key] !== "") {
      params.set(param, preset[key]);
    }
  });
  const query = params.toString();
  return query ? `${LIST_PATH}/new?${query}` : `${LIST_PATH}/new`;
};

export const contactPaths = {
  list: LIST_PATH,
  detail: id => `${LIST_PATH}/${id}`,
  edit: id => `${LIST_PATH}/${id}/edit`,
  create: buildCreatePath,
};

const toId = value => (value ? Number(value) : null);

/** Reads the create preset back from the search params of the create URL. */
export const readCreatePreset = searchParams => ({
  entityId: toId(searchParams.get("entity_id")),
  campaignId: toId(searchParams.get("campaign_id")),
  leadId: toId(searchParams.get("lead_id")),
  fullName: searchParams.get("full_name") ?? "",
  email: searchParams.get("email") ?? "",
  phone: searchParams.get("phone") ?? "",
});
